import { render, staticRenderFns } from "./UserSide.vue?vue&type=template&id=90f3dd92&scoped=true"
import script from "./UserSide.vue?vue&type=script&lang=js"
export * from "./UserSide.vue?vue&type=script&lang=js"
import style0 from "./UserSide.vue?vue&type=style&index=0&id=90f3dd92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f3dd92",
  null
  
)

export default component.exports